module.exports = __webpack_public_path__ + "0c00373d6cafe6ea4c5c26f1b268cd80.jpg";